import request from '@/utils/request'

// 登录
export const login = (data) => request({
  url: '/bd/user/login',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 获取配置信息
export const getConfigInfo = (settingKey) => request({
  url: '/setting/getSettingByKey',
  method: 'get',
  params: { settingKey }
})